module.exports = __webpack_public_path__ + "static/media/undraw_folder_39kl.6c0f6536.svg";